import CompanyService from '@/services/company';

export default {
	namespaced: true,
	state: {
		companyData: {
			tes : 'tes'
		}
	},

	getters: {

	},

	actions: {
		async getCompany({ commit, state, getters, dispatch }) {
			try {
				let response
				const userLogin = JSON.parse(window.localStorage.getItem('user_data'))
				if(userLogin.company_id != 0){
					response = await CompanyService.getCompanyUser(userLogin.company_id)
					commit('SET_COMPANY_DATA', response.data.attributes)
				}else{
					response = null
					commit('SET_COMPANY_DATA', null)
				}

				return response
			} catch (e) {
				console.log(e)
			}
			
		},
		async createCompany({ commit, state, getters, dispatch }, payload) {
			try {
				const response = await CompanyService.createCompany({
					...payload
				})

				return response
			} catch (e) {
				console.log(e)
			}
		},
		async updateCompany({ commit, state, getters, dispatch }, payload) {
			try {
				const response = await CompanyService.updateCompany({
					...payload
				})

				return response
			} catch (e) {
				console.log(e)
			}
		},
		async updateCompanyAttachment({ commit, state, getters, dispatch }, payload) {
			try {
				const response = await CompanyService.updateCompanyAttachment({
					...payload
				})

				return response
			} catch (e) {
				console.log(e)
			}
		},
		async removeImage({commit, state, getters, dispatch}, payload) {
			try{
				const response = await CompanyService.removeImage(payload);
				return response
			}catch(e){
				console.log(e)
			}
		},
	},

	mutations: {
		SET_COMPANY_DATA (state, payload) {
			state.companyData = payload
		}
	}
};
